import { useState } from 'react';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuRadioGroup,
    DropdownMenuRadioItem,
    DropdownMenuTrigger,
} from '~/primitives/dropdown-menu';
import { cn } from '~/util';
import { useFieldContext } from '~/util/hooks/useFormContext';
import {
    FieldLabelWithError,
    FieldWithErrorProps,
} from './FieldLabelWithError';
import { useDisableFormContext } from '../DisableContext';
import { BanLevelTags } from '~/partials/Tags';
import { InteractableDataWrapper } from '~/partials/InteractableDataWrapper';

export function BanLevelField({
    placeholder,
    classname,
    allowNull = false,
    forceDisabled = false,
    showDataWrapperStyling = false,
    ...labelProps
}: {
    placeholder: string;
    classname?: string;
    allowNull?: boolean;
    forceDisabled?: boolean;
    showDataWrapperStyling?: boolean;
} & FieldWithErrorProps) {
    const field = useFieldContext<number | null>();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const disabled = useDisableFormContext();

    return (
        <FieldLabelWithError<number | null> {...labelProps}>
            <DropdownMenu open={dropdownOpen} onOpenChange={setDropdownOpen}>
                <DropdownMenuTrigger disabled={disabled || forceDisabled}>
                    <InteractableDataWrapper
                        id={field.name}
                        disabled={disabled || forceDisabled}
                        open={dropdownOpen}
                        className={cn(
                            !showDataWrapperStyling &&
                                'bg-transparent hover:bg-transparent pl-0 w-fit',

                            field.state.value != null
                                ? 'text-secondary-foreground p-3'
                                : 'text-secondary-light',
                            classname,
                            disabled && 'opacity-50 cursor-not-allowed',
                        )}
                        required={labelProps.required}
                    >
                        {field.state.value !== null ? (
                            <BanLevelTags item={field.state.value} />
                        ) : (
                            placeholder
                        )}
                    </InteractableDataWrapper>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="start">
                    <DropdownMenuRadioGroup
                        value={
                            field.state.value != null
                                ? String(field.state.value)
                                : ''
                        }
                        onValueChange={(value) => {
                            field.handleChange(
                                value === '' ? null : Number(value),
                            );
                            setDropdownOpen(false);
                        }}
                    >
                        {allowNull && (
                            <DropdownMenuRadioItem
                                key="null"
                                value=""
                                className="text-lg cursor-pointer"
                            >
                                {placeholder}
                            </DropdownMenuRadioItem>
                        )}
                        {['0', '1', '2', '3', '4'].map((status) => (
                            <DropdownMenuRadioItem
                                key={status}
                                value={status}
                                className="text-lg cursor-pointer"
                            >
                                <BanLevelTags item={Number(status)} />
                            </DropdownMenuRadioItem>
                        ))}
                    </DropdownMenuRadioGroup>
                </DropdownMenuContent>
            </DropdownMenu>
        </FieldLabelWithError>
    );
}
